export function generateSelectItemTestId(value: string) {
  return `select-item-${value}`;
}
